/**
 * Experience Details Hook
 *
 * Fetches basic experience information (title, location, images, guide, etc.)
 *
 * Epic: MVP 1.20 - Dynamic Experience Page Layout
 */

import { useState, useEffect, useCallback } from 'react';
import apiRequest from '../../services/api';

/**
 * Fetch experience details
 * @param {string} experienceId - Experience UUID
 * @returns {Object} { data, loading, error, refetch }
 */
export function useExperienceDetails(experienceId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDetails = useCallback(async () => {
    if (!experienceId) {return;}

    try {
      setLoading(true);

      const result = await apiRequest(`/api/v1/experiences/${experienceId}`);
      setData(result.data || result);
      setError(null);
    } catch (err) {
      setError(err.message || 'Failed to load experience details');
      console.error('Error loading experience details:', err);
    } finally {
      setLoading(false);
    }
  }, [experienceId]);

  useEffect(() => {
    fetchDetails();
  }, [experienceId]);

  return { data, loading, error, refetch: fetchDetails };
}
